import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accounts: [],
      spinnerClass: "",
      dataClass: "collapse"
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +   "/account/detailsReport",
        this.props.data
      )
      .then(res => {
        this.setState({
          accounts: res.data.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      });
  }

  tabHeader() {
    return (
      <tr>
        <th className="border p-1 font-weight-bold" width="300px">
          Type
        </th>
        <th className="border p-1 font-weight-bold" width="150px">
          Amount
        </th>
      </tr>
    );
  }

  tabRow() {
    return this.state.accounts.map(obj => {
      if (obj._id.txntype === "Expense") obj.totalAmount *= -1;
      var currParts = obj.totalAmount.toString().split(".");
      var curr =
        currParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (currParts[1] ? "." + currParts[1] : ".00");

      return (
        <tr key={obj._id.type}>
          <td className="border p-1">{obj._id.type}</td>
          <td className="border p-1">{curr}</td>
        </tr>
      );
    });
  }

  DisplayFilter() {
    var arrFrom = new Date(this.props.data.fromDate).toDateString().split(" ");
    var arrTo = new Date(this.props.data.toDate).toDateString().split(" ");
    return (
      "( " +
      arrFrom[2] +
      "-" +
      arrFrom[1] +
      "-" +
      arrFrom[3] +
      " to " +
      arrTo[2] +
      "-" +
      arrTo[1] +
      "-" +
      arrTo[3] +
      " )"
    );
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">{this.props.data.txnType} Details Report</h3>
        <div align="center"> {this.DisplayFilter()}</div>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>{this.tabHeader()}</thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default Account;
